import React from 'react'

import { ActionIcon, Tooltip } from '@mantine/core'

import { FaIcon } from '#components/FaIcon'

import styles from './SideBySide/DragHandle.module.scss'

export function SidebarToggleButton({
  isExplorerClosed,
  onToggle,
}: {
  isExplorerClosed: boolean
  onToggle: () => void
}) {
  const label = isExplorerClosed ? 'Show sidebar' : 'Hide sidebar'

  return (
    <Tooltip label={label} position="right" withinPortal>
      <ActionIcon
        aria-label={label}
        className={styles.dragHandle_tab}
        variant="transparent"
        onClick={onToggle}
        // without this, pressing the tab starts a resize drag
        onMouseDown={(e: React.MouseEvent) => e.stopPropagation()}
        onTouchStart={(e: React.TouchEvent) => e.stopPropagation()}
      >
        <FaIcon
          icon={isExplorerClosed ? 'fa-chevron-right' : 'fa-chevron-left'}
          fz={10}
        />
      </ActionIcon>
    </Tooltip>
  )
}
